import { get } from 'lodash';
import uiSelector from 'services/UI/selectors';
import { RootState } from 'store';
import { useAppSelector } from 'store/hooks';
import { PATH_LOADING } from './constants';

export type MyState = RootState['shop'];
export const getCurrentState = (state: RootState): MyState => state['shop'];

const selector = <T = MyState>(key: keyof T, defaultValue?: any) => useAppSelector(state => get(getCurrentState(state), key, defaultValue));

const getShopInfo = () => selector('shopInfo') as MyState['shopInfo'];

const getShopInfoLoading = () => uiSelector.getLoading(PATH_LOADING.getShopInfo) as boolean;
const getStaffsBookingOnlineLoading = () => uiSelector.getLoading(PATH_LOADING.getStaffList) as boolean;

const data = {
  staffs: () => selector('staffs') as MyState['staffs'],
  staffsBookingOnline: () => selector('staffsBookingOnline') as MyState['staffsBookingOnline'],
  categories: () => selector('categories') as MyState['categories'],
  socialMedia: () => selector('socialMedia') as MyState['socialMedia'],
  quickBookingService: () => selector('quickBookingService') as MyState['quickBookingService'],
  allSetting: () => selector('allSetting') as MyState['allSetting'],
  allShopSetting: () => selector('allShopSetting') as MyState['allShopSetting'],
  settingDepositBooking: () => selector('settingDepositBooking') as MyState['settingDepositBooking'],
  notification: () => selector('notification') as MyState['notification'],
};

const shopSelectors = {
  getShopInfo,
  getShopInfoLoading,
  data,
  getStaffsBookingOnlineLoading,
};

export default shopSelectors;
